export default "__VITE_ASSET__Djh8Xm7u__"